import AjaxManager from "../ajaxManager";

export default class FreeCancelPoliciesListener
{
    constructor()
    {
        this.eventDelegation();
        this.ajaxManager = new AjaxManager();
    }

    eventDelegation()
    {
        const callback = (data) => {
            $('#free_cancel_policies_content').html(data);
            myApp.customModalManager.openModal('#free_cancel_policies', true);
        };

        $('[data-trigger="free-cancel-policies"]').click((event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            this.ajaxManager.ajaxCall(
                'GET',
                myApp.config.routing.freeCancelPoliciesDateRangesList,
                {
                    cholloId: $('[data-trigger="free-cancel-policies"]').data('cholloid')
                },
                callback
            );
        });
    }
}
